// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
 
 
import type { FC } from 'react';

import { Icon, type IconProps } from './../IconWrapper';

const SvgDotIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <circle cx={12} cy={12} r={7.5} />
  </Icon>
);
export default SvgDotIcon;
SvgDotIcon.displayName = 'SvgDotIcon';
